/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Col, Row } from 'reactstrap';

const FormDias = ({
  plan,
  valMinimo,
  valMaximo,
  posicion,
  callback,
  total,
  callbackError,
}) => {
  const methods = useForm({ mode: 'onChange' });
  const { register, setValue, errors } = methods;

  useEffect(() => {
    setValue(plan.planCodigo, plan.diasNumero ? plan.diasNumero : 0);
  }, []);

  return (
    <div>
      <FormProvider {...methods}>
        <form>
          <Row>
            <Col lg={7} md={12} sm={12} xs={12}>
              <Row>
                <Col lg={10} md={10} sm={10} xs={12}>
                  <input
                    className="input-btaemp-resumen font-source-sans-pro-semi-bold"
                    name={plan.planCodigo}
                    type="number"
                    ref={register({
                      validate: (value) => {
                        if (RegExp(/^[0-9\b]+$/).test(value)) {
                          if (value < valMinimo) {
                            callbackError(value, posicion);
                            return `Minimo ${valMinimo} dias`;
                          }
                          if (value > valMaximo) {
                            callbackError(value, posicion);
                            return `Maximo ${valMaximo} dias`;
                          }
                          callback(value, posicion);
                          return true;
                        } else {
                          callbackError(value, posicion);
                          return 'Ingrese solo numeros enteros';
                        }
                      },
                    })}
                  />
                  <strong className="error-msg-input">
                    {errors[plan.planCodigo] && errors[plan.planCodigo].message}
                  </strong>
                </Col>
                <div className="col-sm-2 mt-2">
                  <div className="value-plan-resumen font-source-sans-pro-semi-bold">
                    Días
                  </div>
                </div>
              </Row>
            </Col>
            <div className=" col-lg-5 mt-2">
              <div className="value-plan-resumen font-source-sans-pro-semi-bold">
                {total}
              </div>
            </div>
          </Row>
        </form>
      </FormProvider>
    </div>
  );
};

export default FormDias;
